// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Citation } from "./Citation";
import {
  CitationFromJSON,
  CitationFromJSONTyped,
  CitationToJSON,
  CitationToJSONTyped,
} from "./Citation";

/**
 *
 * @export
 * @interface ISO19115Keywords
 */
export interface ISO19115Keywords {
  /**
   * In het algemeen gebruikte woorden of geformaliseerde zinnen om een onderwerp te beschrijven.
   */
  values: Array<string>;
  /**
   *
   */
  thesaurus?: Citation | null;
}

/**
 * Check if a given object implements the ISO19115Keywords interface.
 */
export function instanceOfISO19115Keywords(value: object): value is ISO19115Keywords {
  if (!("values" in value) || value["values"] === undefined) return false;
  return true;
}

export function ISO19115KeywordsFromJSON(json: any): ISO19115Keywords {
  return ISO19115KeywordsFromJSONTyped(json, false);
}

export function ISO19115KeywordsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ISO19115Keywords {
  if (json == null) {
    return json;
  }
  return {
    values: json["values"],
    thesaurus:
      json["thesaurus"] === undefined
        ? undefined
        : json["thesaurus"] === null
        ? null
        : CitationFromJSON(json["thesaurus"]),
  };
}

export function ISO19115KeywordsToJSON(json: any): ISO19115Keywords {
  return ISO19115KeywordsToJSONTyped(json, false);
}

export function ISO19115KeywordsToJSONTyped(
  value?: ISO19115Keywords | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    values: value["values"],
    thesaurus: CitationToJSON(value["thesaurus"]),
  };
}
